import React, { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';

const FALLBACK = ['CAD', 'USD', 'EUR', 'GBP', 'CNY', 'JPY', 'MXN', 'AUD'];
let cache = null;

// Currency dropdown using the enabled currencies from Admin → Settings → Currency (CAD always first).
export const CurrencySelect = ({ value, onChange, disabled, className = '', testId = 'currency-select' }) => {
  const { api } = useAuth();
  const [list, setList] = useState(cache || FALLBACK);
  useEffect(() => {
    if (cache) return;
    api().get('/currency/settings').then(r => {
      const en = r.data?.enabled_currencies?.length ? r.data.enabled_currencies : FALLBACK;
      cache = ['CAD', ...en.filter(c => c !== 'CAD')];
      setList(cache);
    }).catch(() => {});
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  const opts = value && !list.includes(value) ? [...list, value] : list;
  return (
    <select value={value || 'CAD'} onChange={(e) => onChange(e.target.value)} disabled={disabled}
      className={`h-9 border border-slate-200 rounded-sm px-2 text-sm bg-white mono ${className}`} data-testid={testId}>
      {opts.map(c => <option key={c} value={c}>{c}</option>)}
    </select>
  );
};

// Unit cost to show: typed purchase cost, else last received PO cost (CAD).
export const itemUnitCost = (it) => (it?.purchase_cost !== null && it?.purchase_cost !== undefined && it?.purchase_cost !== ''
  ? { value: Number(it.purchase_cost), currency: it.purchase_currency || 'CAD', source: 'manual' }
  : it?.last_po_cost ? { value: Number(it.last_po_cost), currency: 'CAD', source: 'po', po: it.last_po_number } : null);

export const UnitCostText = ({ item, testId }) => {
  const c = itemUnitCost(item);
  if (!c) return <span className="text-slate-400" data-testid={testId}>—</span>;
  return (
    <span className="mono" data-testid={testId}>
      {c.value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 4 })} <span className="text-[10px] text-slate-500">{c.currency}</span>
      {c.source === 'po' && <span className="block text-[10px] text-slate-400 font-sans">from last PO{c.po ? ` ${c.po}` : ''}</span>}
    </span>
  );
};

export default CurrencySelect;
